import { Sparkles, FileText, CalendarClock, X } from "lucide-react";
import type { SourceAction } from "../types";
import type { I18n } from "@lingui/core";
import { msg } from "@lingui/core/macro";

export interface EventActionsConfig {
  onGenerateBrief?: () => void;
  onSummarizePrep?: () => void;
  onReschedule?: () => void;
  onCancel?: () => void;
}

export function buildEventActions(cfg: EventActionsConfig, i18n: I18n): SourceAction[] {
  return [
    {
      id: "brief",
      label: i18n._(msg`Genera brief`),
      icon: <Sparkles className="h-3.5 w-3.5" />,
      variant: "primary",
      disabled: !cfg.onGenerateBrief,
      onSelect: () => cfg.onGenerateBrief?.(),
    },
    {
      id: "summarize-prep",
      label: i18n._(msg`Riassumi prep`),
      icon: <FileText className="h-3.5 w-3.5" />,
      disabled: !cfg.onSummarizePrep,
      onSelect: () => cfg.onSummarizePrep?.(),
    },
    {
      id: "reschedule",
      label: i18n._(msg`Sposta`),
      icon: <CalendarClock className="h-3.5 w-3.5" />,
      disabled: !cfg.onReschedule,
      onSelect: () => cfg.onReschedule?.(),
    },
    {
      id: "cancel",
      label: i18n._(msg`Cancella`),
      icon: <X className="h-3.5 w-3.5" />,
      variant: "destructive",
      disabled: !cfg.onCancel,
      onSelect: () => cfg.onCancel?.(),
    },
  ];
}
